import { useParams } from 'react-router-dom'

export const useWorkOrderIdParam = (): string => {
  const params: any = useParams()
  return params?._id ?? undefined
}
